export class Controller {

    $onChanges() {
        this.tooltipKey = ({
            ACTIVE: 'sp-account-status.active',
            EXPIRED: 'sp-account-status.expired',
            IR_PENDING: 'sp-account-status.ir-pending',
            PENDING: 'sp-account-status.pending',
            UNKNOWN: 'sp-account-status.unknown',
        })[this.accountStatus];

        this.iconClass = ({
            ACTIVE: 'fa fa-lg fa-check',
            EXPIRED: 'fa fa-lg fa-history',
            IR_PENDING: 'far fa-lg fa-clock',
            PENDING: 'far fa-lg fa-clock',
            UNKNOWN: 'far fa-lg fa-question-circle',
        })[this.accountStatus];

        this.textClass = ({
            ACTIVE: 'text-success',
            EXPIRED: 'text-danger',
            IR_PENDING: 'text-warning',
            PENDING: 'text-warning',
            UNKNOWN: 'text-muted',
        })[this.accountStatus];
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-account-status/sp-account-status.controller.js